import React from 'react'

const Placeholder = () => (
  <div className='row'>
    <div className='col-12 px-0'>
      <div className='row align-items-center h-100'>
        <div className='col-1'>
          <span className='d-block radius-circle bg-ui-3 px-1 py-1' />
        </div>
        <div className='col ml-1'>
          <div className='row'>
            <div className='col-4 py-half bg-ui-3 radius' />
          </div>
        </div>
      </div>
    </div>
  </div>
)

export default Placeholder



// WEBPACK FOOTER //
// ./src/Participant/MyOrders/ProductOrderList/ProductOrderItem/ProductDetails/TrackingStatus/Placeholder.js